import React from 'react'

export default function () {
  const html = `<header><h3 class="product-name">{{{data.name}}}</h3><button class="cancel close-mkl-pc" type="button"><span>Cancel</span></button></header>
  <section class="choices">
  </section>`
  return <script type="text/html" id="tmpl-mkl-pc-configurator-toolbar" dangerouslySetInnerHTML={{__html: html}}/>
}
